<template>
  <span></span>
</template>
<script>
import { mapMutations } from "vuex";
export default {
  name: "abLaod",
  props: {
    url: { required: true }, // 获取数据请求的url
    value: { required: true }, // 赋值目标对象
    method: { default: "postForm" }, // 请求方式 默认post 可以改为 postForm
    postKey: { required: false }, // 如果设置则逗号分隔单个字段提交到后台
    afterFn: { type: Function }, // 后置动作
    params: { required: false },
    dataKey: { required: false, default: "data" },
    showLoading : {default: true}
  },
  data() {
    return {
      oldData: []
    };
  },
  created: function() {
    // 没有参数则 调回
    /*
     * if(vnode.data.attrs.noParamBack && !params){ self.$router.push({
     * name: self.backRoute }) }
     */
    this.load();
  },
  methods: {
    load() {
      let params = this.params;
      if (!params) {
        params = this.$route.params;
      }
      if (params.$add) {
        return;
      }

      let rtn = this.abHttpUtil[this.method](this.url, params);
      let loading = function(){};
      if(this.showLoading){
    	  loading = this.$Message.loading({
              content: '加载中...',
              duration: 0
          });
      }
      
      
      rtn.then(
        result => {
          loading();
          if (result.isOk) {
            this.oldData.push(result[this.dataKey]);
            this.$emit("input", result[this.dataKey]);
            this.$emit("afterFn", result.data);
            this.$root.$emit("abLoaded", result.data || {}, this.url);

            updateEditPageTitle(this.$vnode,result);

          } else {
            self.$Message.error(result.msg);
          }
        },
        function(errorCode) {
          loading();
          self.$Message.error("请求失败!" + errorCode);
        }
      );
    }
  }
};
</script>
